export { default } from './CopyNotification';
